import { combineReducers } from "redux";
import uiReducer from "./uiReducer";
import authReducer from "./authReducer";
import staffingReducer from "./staffingReducer";
import twilioReducer from "./twilioReducer"

export default combineReducers({
  ui: uiReducer,
  auth: authReducer,
  staffing: staffingReducer,
  twilio:twilioReducer,
});
